/* =============================================
   LUARARTS — Collection Filter JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // Reduce easy video downloading from the browser UI and block right-click menu.
  function protectVideos(scope = document) {
    scope.querySelectorAll('video').forEach((video) => {
      video.setAttribute('controlsList', 'nodownload noplaybackrate');
      video.setAttribute('disablePictureInPicture', '');
      video.addEventListener('contextmenu', (event) => event.preventDefault());
    });
  }

  protectVideos();



  // ── Accordion groups ──
  document.querySelectorAll('.la-filter-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.la-filter-group');
      group.classList.toggle('is-open');
    });
  });

  // ── Checkbox → apply filter (URL update) ──
  document.querySelectorAll('.la-filter-cb').forEach(cb => {
    cb.addEventListener('change', () => {
      applyFilters();
    });
  });

  // ── Price range → apply on Enter ──
  document.querySelectorAll('.la-price-input').forEach(input => {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') applyFilters();
    });
    input.addEventListener('blur', () => applyFilters());
  });

  // ── Sort ──
  const sortSelect = document.querySelector('.la-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ── Apply filters: build URL from checked boxes ──
  function applyFilters() {
    const url = new URL(window.location);

    // Clear existing filter params
    const keysToDelete = [];
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('filter.')) keysToDelete.push(key);
    }
    keysToDelete.forEach(k => url.searchParams.delete(k));

    // Add checked values
    document.querySelectorAll('.la-filter-cb:checked').forEach(cb => {
      url.searchParams.append(cb.name, cb.value);
    });

    // Add price range
    document.querySelectorAll('.la-price-input').forEach(input => {
      if (input.value) url.searchParams.set(input.name, input.value * 100);
    });

    // Reset to page 1
    url.searchParams.delete('page');

    window.location.href = url.toString();
  }

  // ── Mobile sidebar toggle ──
  const mobBtn = document.getElementById('la-mob-filter-btn');
  const sidebar = document.getElementById('la-sidebar');

  if (mobBtn && sidebar) {
    // Add close button inside sidebar
    const closeBtn = document.createElement('button');
    closeBtn.className = 'la-sidebar-close la-icon-btn';
    closeBtn.innerHTML = '✕';
    closeBtn.setAttribute('aria-label', 'Close filters');
    closeBtn.style.cssText = 'position:absolute;top:1rem;right:1rem;display:none;';
    sidebar.prepend(closeBtn);

    mobBtn.addEventListener('click', () => {
      sidebar.classList.add('mobile-open');
      closeBtn.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });

    closeBtn.addEventListener('click', closeSidebar);

    // Tap outside to close
    document.addEventListener('click', (e) => {
      if (sidebar.classList.contains('mobile-open') &&
          !sidebar.contains(e.target) &&
          e.target !== mobBtn) {
        closeSidebar();
      }
    });

    function closeSidebar() {
      sidebar.classList.remove('mobile-open');
      document.body.style.overflow = '';
    }
  }

});
